import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { OAUTH_CONSENT_REQUESTED_WITH_HEADER, OAUTH_CONSENT_REQUESTED_WITH_VALUE } from '@shared/constants/oauth';
import {
  IOAuthConsentDecisionRequest,
  IOAuthConsentDecisionResponse,
  IOAuthConsentLoadResponse,
  IOAuthInteractionDetails,
  IOAuthOrganizationRequest,
  IOAuthOrganizationResponse,
} from '@shared/interfaces/oauth.interface';

import { RestBuilder } from '../helpers/rest.builder';

/** Marks the decision as sent by this page: browsers don't send a custom header from another origin without a preflight. */
const CONSENT_HEADERS: HttpHeaders = new HttpHeaders({
  [OAUTH_CONSENT_REQUESTED_WITH_HEADER]: OAUTH_CONSENT_REQUESTED_WITH_VALUE,
});

@Injectable({
  providedIn: 'root',
})
export class OAuthApi {
  private restBuilder: RestBuilder;

  constructor(private httpClient: HttpClient) {
    this.restBuilder = new RestBuilder();
  }

  // GET /api/v1/oauth/interaction/{uid}/details
  public getInteractionDetails(uid: string): Observable<IOAuthInteractionDetails> {
    return this.httpClient.get<IOAuthInteractionDetails>(this.restBuilder.create().oauthInteractionDetails(uid).getApiUrl());
  }

  // POST /api/v1/oauth/interaction/{uid}/organization
  public submitOrganization(uid: string, organization: string): Observable<IOAuthOrganizationResponse> {
    const body: IOAuthOrganizationRequest = { organization };
    return this.httpClient.post<IOAuthOrganizationResponse>(
      this.restBuilder.create().oauthInteractionOrganization(uid).getApiUrl(),
      body,
    );
  }

  // GET /api/v1/oauth-consent/{requestId}
  public getConsent(requestId: string): Observable<IOAuthConsentLoadResponse> {
    return this.httpClient.get<IOAuthConsentLoadResponse>(this.restBuilder.create().oauthConsent(requestId).getApiUrl(), {
      headers: CONSENT_HEADERS,
    });
  }

  // POST /api/v1/oauth-consent/{requestId}/decision
  public decideConsent(requestId: string, approve: boolean): Observable<IOAuthConsentDecisionResponse> {
    const body: IOAuthConsentDecisionRequest = { approve };
    return this.httpClient.post<IOAuthConsentDecisionResponse>(
      this.restBuilder.create().oauthConsentDecision(requestId).getApiUrl(),
      body,
      { headers: CONSENT_HEADERS },
    );
  }
}
